export default __webpack_public_path__ + "static/media/resultados-tiempo-real.8ebb5c10.png";